import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { ConfigProvider } from "melco-ui";
import { useDataMappingDropdownData } from "../../hooks/designMappings/useDataMappingDropdown";
import { DataMappingType } from "../inputFormats/SelectDataMappingType";

type SelectDataMappingProps = {
  name: string;
  inputFormatId: string;
  dataMappingType: DataMappingType | undefined;
};

export const SelectDataMapping: React.FC<SelectDataMappingProps> = ({
  name,
  inputFormatId,
  dataMappingType,
}) => {
  const { t } = useTranslation();

  const { isLoading, isFetching, data, isPreviousData } =
    useDataMappingDropdownData(inputFormatId);

  const dataMappingOptions = (data ?? [])
    .filter(({ config_type }) => config_type === dataMappingType)
    .map((o) => ({
      value: o.id ?? "",
      label: o.name ?? "",
    }));

  return (
    <ConfigProvider renderEmpty={() => <>{t("global.fallback.none")}</>}>
      <SelectField
        name={name}
        label={t(
          "designMappings.actions.designConfiguration.form.label.mapping_id"
        )}
        loading={isPreviousData ? isFetching : isLoading}
        style={{ width: "100%" }}
        options={dataMappingOptions}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
        valueConverter={{
          toSelectValue: (value) => value as string,
          toFormValue: (value) => value ?? "",
        }}
      />
    </ConfigProvider>
  );
};
